require("!!/Users/songseunggeun/buffy-home/build-a-farm/node_modules/script-loader/addScript.js")(require("!!/Users/songseunggeun/buffy-home/build-a-farm/node_modules/raw-loader/index.js!/Users/songseunggeun/buffy-home/build-a-farm/vendor/blockly/blocks_compressed.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./vendor/blockly/blocks_compressed.js
 ** module id = 872
 ** module chunks = 0
 **/